interface PricedProcedure {
  price?: number;
  originalPrice?: number;
  promotionId?: string;
  isAvailable?: boolean;
}

export const getAvailableProcedures = <TProcedure extends PricedProcedure>(
  procedures: TProcedure[],
): TProcedure[] => {
  return procedures.filter((procedure) => procedure.isAvailable !== false);
};

export const sumProcedurePrices = (procedures: PricedProcedure[]): number => {
  return getAvailableProcedures(procedures)
    .reduce((total, procedure) => total + (procedure.price ?? 0), 0);
};

export const sumProcedureOriginalPrices = (procedures: PricedProcedure[]): number => {
  return getAvailableProcedures(procedures)
    .reduce((total, procedure) => total + (procedure.originalPrice ?? procedure.price ?? 0), 0);
};

export const isProcedureDiscounted = (procedure: PricedProcedure): boolean => {
  return procedure.originalPrice != null
    && procedure.price != null
    && procedure.price < procedure.originalPrice;
};

export const hasProceduresPromotion = (procedures: PricedProcedure[]): boolean => {
  return getAvailableProcedures(procedures).some((procedure) => Boolean(procedure.promotionId));
};

export const hasProceduresDiscount = (procedures: PricedProcedure[]): boolean => {
  return getAvailableProcedures(procedures).some(isProcedureDiscounted);
};

export const getProcedurePromotionIds = (procedures: PricedProcedure[]): string[] => {
  const promotionIds = getAvailableProcedures(procedures)
    .map((procedure) => procedure.promotionId)
    .filter((promotionId): promotionId is string => Boolean(promotionId));

  return Array.from(new Set(promotionIds));
};
